import { Pipe, PipeTransform, inject } from '@angular/core'
import { Maybe, WarrantyStatus } from '@generated/sammathnaur.graphql'
import { TranslateService } from '@ngx-translate/core'
import { constantCase } from 'change-case'

@Pipe({
    name: 'translateWarrantyStatusPipe',
    standalone: false
})
export class TranslateWarrantyStatusPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService)

  public transform(warrantyStatus?: Maybe<WarrantyStatus>): string {
    return this.translateService.instant(`TRANSLATE_WARRANTY_STATUS.${constantCase(warrantyStatus || WarrantyStatus.Active)}`)
  }
}
